import React from 'react';
import { Link } from 'react-router-dom';

const LandingPageFooter = () => {
  return (
    <footer className="bg-[#2C3E50] text-white py-8">
      <div className="container mx-auto px-4 max-w-[1320px]">
        <div className="text-center">
          <img 
            src="/assets/img/brand/logo-light.webp" 
            alt="Trademark Vector" 
            className="h-12 w-auto mx-auto mb-4"
          />
          <p className="text-sm text-gray-300">
            © {new Date().getFullYear()} Trademark Vector. All rights reserved.
          </p>
          <div className="mt-4 flex items-center justify-center space-x-6">
            <Link to="/privacy" className="text-sm text-gray-300 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-300 hover:text-white transition-colors">
              Terms & Conditions
            </Link>
          </div>
          <p className="text-xs text-gray-400 mt-4">
            Trademark registration services provided nationwide. USPTO filing fees not included in service prices.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
